<template>
  <div>
    <CCard>
      <CDataTable :items="items" :fields="fields" fixed hover striped bordered>
        <template ##="{item}">
          <td>{{ item.id }}</td>
        </template>
        <template #type="{item}">
          <td style="text-align:center">{{item.type}}</td>
        </template>
        <template #wallet_address="{item}">
          <td style="text-align: left">{{ item.wallet_address | truncate(30) }}</td>
        </template>
        <template #message="{item}">
          <td>{{ item.message | truncate(30) }}</td>
        </template>
        <template #created_at="{item}">
          <td style="text-align: center">{{ item.created_at | moment(dateFormat) }}</td>
        </template>
        <template #action="{item}">
          <td style="text-align: center">
            <CButton @click="getDetails(item)">
                <img src="@/assets/images/ico-edit-user.svg" alt class="hand edit-icon" />
              </CButton>
              <CButton @click="openModal(item)">
                <img src="@/assets/images/ico-del-user.svg" alt class="hand edit-icon" />
              </CButton>
          </td>
        </template>
      </CDataTable>
    </CCard>
    <CModal id="deleteModal" :show.sync="warningModal" :centered="true">
      <template #header>
        <CButtonClose @click="warningModal = false" />
      </template>
      <div class>
        <div class="pb-4 tit-dele">
          <p>{{$t('DELETE_LOGGING_MODAL_TITLE')}}</p>
        </div>
        <div
          class="text-modal"
          v-html="$t('DELETE_LOGGING_MODAL_CONTENT')"
        ></div>
      </div>
      <template #footer>
        <CButton
          class="cancel-btn"
          @click="warningModal = false"
          color="dark"
          variant="outline"
        >{{$t('DELETE_LOGGING_MODAL_BUTTON_CANCEL')}}</CButton>
        <CButton
          @click="deleteLogging(id)"
          class="delete-btn"
          v-if="isAllowedDelete"
        >{{$t('DELETE_LOGGING_BUTTON_DELETE')}}</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import {endpoints, Constants, env } from '@/constants';
import { mapState, mapActions, mapGetters } from 'vuex';
import StakingBadge from '@/components/StakingBadge';
import stringHelper from '@/utils/string-helper';
import responseHelper from '@/utils/response-helper';

export default {
  name: 'LoggingListTable',
  components: {
    StakingBadge,
  },
  data(){
    return {
      dateFormat: Constants.dateFormat,
      fields: [
        '#',
        {
          key: 'created_at',
          label: this.$t('LOGGING_LIST_TABLE_COMPONENT_DATE_COL'),
          _style: 'min-width: 160px; text-align: center;',
        },
        {
          key: 'type',
          label: this.$t('LOGGING_LIST_TABLE_COMPONENT_TYPE_COL'),
          _style: 'text-align: center;',
        },
        {
          key: 'wallet_address',
          label: this.$t('LOGGING_LIST_TABLE_COMPONENT_WALLET_ADDRESS_COL'),
        },
        {
          key: 'message',
          label: this.$t('LOGGING_LIST_TABLE_COMPONENT_MESSAGE_COL'),
        },
        {
          key: 'action',
          label: this.$t('LOGGING_LIST_TABLE_COMPONENT_ACTION_COL'),
          _style: 'text-align: center;',
        },
      ],
      warningModal: false,
      name: '',
    }
  },
  props: {
    getLoggings: {
      type: Function,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    activePage: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 0,
    },
    isAllowedDelete: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {},
  methods: {
    getDetails(item) {
      this.$router.push(`logging/details/${item.id}`);
    },
    async deleteLogging(id) {
      try {
        await this.$http.delete(endpoints.deleteLogging(id));
        this.$notify({
          group: 'notifications',
          type: 'success',
          title: this.$t('DELETE_LOGGING_NOTIFY_TITLE_SUCCESSFULLY'),
          text: this.$t('DELETE_LOGGING_NOTIFY_MESSAGE_DELETE_SUCCESSFULLY'),
        });
        this.warningModal = false;
        this.getLoggings();
      } catch (err) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('LOGGING_LIST_PAGE_NOTIFY_TITLE_ERROR'),
          text: responseHelper.getErrorMessage(err),
        });
      }
    },
    openModal(value) {
      this.id = value.id;
      this.warningModal = true;
    },
  }
}
</script>
<style lang="scss">
  .table {
    margin-bottom: 0;
  }

  .modal-body {
    padding: 1.3rem 1.5rem;
    .tit-dele {
      p {
        font-size: 18px;
      }
    }
  }

  .modal-content {
    width: 85%;
    .modal-header {
      border: none;
      padding: 0 8px;
      display: none;
    }
    .text-modal {
      strong {
        color: #3a4a7f;
        font-weight: 500;
      }
    }
    .modal-footer {
      border: none;
      justify-content: center;
      .delete-btn {
        background-color: #ff5555;
        color: #ffffff;
        width: 150px;
        font-weight: 500;
        font-size: 14px;
        margin: 0 10px;
      }
      .cancel-btn {
        width: 150px;
        border: 2px solid #cbcbcb;
        color: #657187;
        font-weight: 500;
        font-size: 14px;
        margin: 0 10px;
        &:hover {
          background-color: #fff;
        }
      }
    }
  }
</style>
